import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import './plugins'
import store from './store'
import { sync } from 'vuex-router-sync'
import axios from 'axios'
// import { Storage } from '@/util/helpers'

import Message from './components/Message/index.js'
// 引入这个是为了解决有时候图标展示不正常，可以先注释了尝试一下
// import 'material-design-icons-iconfont/dist/material-design-icons.css'
Vue.prototype.$message = Message

Vue.config.productionTip = false

axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
// 添加请求拦截器，在请求头中加token
axios.interceptors.request.use(
  config => {
    if (localStorage.getItem('Authorization')) {
      config.headers.Authorization = localStorage.getItem('Authorization')
    }
    return config
  },
  error => {
    return Promise.reject(error)
  },
)

/* 响应拦截器 */
/* axios.interceptors.response.use(function (response) { // ①10010 token过期（30天） ②10011 token无效
  console.log(response.data.code)
  if (response.data.code === 401) {
    localStorage.setItem('Authorization', null) // 删除已经失效或过期的token（不删除也可以，因为登录后覆盖）
    router.replace({
      path: '/login', // 到登录页重新获取token
    })
  } // else if (response.data.token) { // 判断token是否存在，如果存在说明需要更新token
    // Storage.localSet('token', response.data.token) // 覆盖原来的token(默认一天刷新一次)
  // }
  return response
}, function (error) {
  return Promise.reject(error)
}) */

sync(store, router)

new Vue({
  router,
  vuetify,
  store,
  mounted: function () {
    window.addEventListener('beforeunload', () => {
      // localStorage.removeItem('Authorization')
    })
  },
  render: h => h(App),
}).$mount('#app')
